<div class="subBlockContent" id="confirmWGSProduct">
  <child-header [title]="'Confirm Products'" (closeEvent)="close()"></child-header>
  <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
    (currentLoadingStatus)="onLoading($event)">
  </loading-screen>

  <div class="inner-subBlock-wrapper child-body">

    <div class="pannel-outter-wrapper">
      <!-- Subscription -->
      <ng-container>

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionSubscription" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingSubscription">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#accordionSubscription"
                    href="#collapseSubscription" aria-expanded="true" aria-controls="collapseSubscription">
                    <span class="highlight-text">SUBSCRIPTION</span>
                    <span class="panel-subtitle" id="panelsubtitle">
                      {{ subscriptionItemsPendingList?.length?subscriptionItemsPendingList?.length:"0" }}
                      Subscription(s)
                      <span class="triangle-down"></span>
                    </span>
                  </a>
                </h4>
                <div id="collapseSubscription" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingSubscription">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="inner-subBlock-content">
                        <div>
                          <div class="mTable">
                            <table class="table display-block">
                              <thead>
                                <tr>
                                  <th scope="col" class="pending-description-col" style="width: 40%">DESCRIPTION</th>
                                  <th scope="col" class="align-center" style="width: 10%">QTY</th>
                                  <th scope="col" class="align-right" style="width: 10%">RRP</th>
                                  <th scope="col" class="align-right" style="width: 10%">PRICE</th>
                                  <th scope="col" class="align-right" style="width: 10%">TOTAL</th>
                                  <th scope="col" style="width: 5%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let pendingItem of subscriptionItemsPendingList;index as i">
                                  <tr class="pending-grey-row">
                                    <!-- DESC -->
                                    <td style="padding-left: 50px;" class="position-relative">
                                      <div class="arrowright"><i class="fas fa-caret-right fa-2x"></i>
                                      </div>
                                      <div class="description" style="white-space: nowrap;">
                                        {{pendingItem?.description}}
                                      </div>
                                      <div class="result-info">
                                        <div class="produc-secondary-title-wrapper">
                                          <div class="produc-secondary-title-wrapper pt-2">
                                            <span>DESC:&nbsp;</span>
                                            <span style="padding-left: 15px;">
                                              <input type="text" class="input" maxlength="30"
                                                [(ngModel)]="pendingItem.subscriptionDescription"
                                                (input)="commonService.subscription_customer_ref_validation($event)">
                                            </span>
                                          </div>
                                        </div>
                                        <div class="produc-secondary-title-wrapper pt-2">
                                          <span>STOCK CODE:&nbsp;</span>
                                          <span class="red-bold">{{pendingItem?.stockCode}}</span>
                                        </div>
                                      </div>
                                    </td>
                                    <!-- QTY -->
                                    <td class="align-center">
                                      <input class="align-center input-wrapper input-wrapper-small" disabled type="text"
                                        [value]="pendingItem?.quantity">
                                    </td>
                                    <!-- RRP -->
                                    <td class="align-right">
                                      {{pendingItem?.itemRRPrice}}
                                      <span>/mth</span>
                                    </td>
                                    <!-- Item Price -->
                                    <td class="align-right">
                                      {{pendingItem?.itemPrice}}
                                      <span>/mth</span>
                                    </td>
                                    <!-- Total -->
                                    <td class="align-right">
                                      {{pendingItem?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                                    </td>
                                    <!-- delete icon -->
                                    <td class="align-center vertical-align-mid">
                                      <span id="delete-icon" class="basic-icon delete-icon"
                                        (click)="removeSubscriptionPendingItem(i)" ngbTooltip="Remove"
                                        placement="bottom"></span>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                              <tfoot>
                                <div class="row totalPrice-wrapper">
                                  <div class="col align-center" *ngIf=" pendingTotal !=0 ">
                                    <span><b>Pending Total (Ex GST) </b>
                                      <span class="pendingTotal ">{{totalPriceChange |
                                        currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                                  </div>
                                  <div class="col align-center " *ngIf="pendingTotal==0 ">
                                    <span>
                                      <b>Pending Total (Ex GST)</b>
                                      <span class="pendingTotal ">
                                        {{ 0 | currency:'AUD':'symbol-narrow':'.2-2'}}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </tfoot>
                            </table>
                          </div>
                          <div class="row ">
                            <div class="col button-center ">
                              <button class="button button-red button-large button-center-right" (click)="confirmSubscription()">Confirm All</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>

  </div>
</div>